import { userApiPost } from "./apiPost";

export const getBreachList = userApiPost('get-breaches-basic-info')

export const createBreach = userApiPost('create-breach')

export const getBreachDetails = userApiPost('get-breach-detail')

export const updateBreach = userApiPost('update-breach-detail')

export const getBreachAction = userApiPost('get-breach-actions')

export const createBreachAction = userApiPost('create-breach-action')

export const updateBreachAction = userApiPost('update-breach-action')

export const updateBreachPhaseStatus = userApiPost('update-breach-phase-status')

export const createAlertBreach = userApiPost('create-alert-breach')

export const getBreachIdsByAlertId = userApiPost('get-breach-ids-by-alert-id')
